
export default {
	EN: {
		messages: {
			email: (field) => `${field} must be a valid email`,
			required: (field) => `Please fill out ${field}`,
			length: (field) => `${field} value is not valid`,
			regex: (field) => {
				let fieldName = field.toLowerCase();
				if (fieldName.includes('phone')) {
					return `Phone should be 11 number & starts by 01.`;
				} else if (fieldName.includes('name')) {
					return `The name can only be in English characters.`;
				} else if (fieldName.includes('amount')) {
					return 'Amount must be numbers'
				}
				return `Password must be min 8 characters and contain at least 1 Uppercase, 1 Lowercase, 1 Number and 1 Special character`;
			},
			min: (field, number) => `${field} must be at least ${number} characters.`,
			max: (field, number) => {
				let fieldName = field.toLowerCase();
				if (fieldName.includes('name')) {
					return `The name can only be ${number} characters maximum!`;
				}
				return `${field} must not exceed ${number} characters.`
			},
			is: `Password & confirm password are not the same.`
		},
		attributes: {
			email: 'Email address',
			emailAddress: 'Email address',
			regex: 'Password',
			oldPassword: 'Old password',
			newPassword: 'New password',
			newRePassword: 'New password confirmation',
			password: 'Password',
			userPassword: 'Password',
			name: 'Name',
			phone: 'Phone',
			msg: 'Message',
			amount: 'Gift Value',
			creditAmount: 'Amount',
			card_number: 'Card number',
			expiry_date: 'Expiry date',
			card_security_code: 'cvv',
			phoneNumber: 'Phone',
			phoneNumbers: 'Phone numbers',
			prefix: 'Promo name'
		}
	},
	AR: {
		attributes: {
			email: 'البريد الاليكتروني',
			emailAddress: 'البريد الاليكتروني',
			regex: 'كلمة السر',
			password: 'كلمة السر',
			oldPassword: 'كلمة السر القديمة',
			newPassword: 'كلمة السر الجديدة',
			newRePassword: 'تأكيد كلمة السر الجديدة',
			userPassword: 'كلمة السر',
			name: 'الأسم',
			phone: 'رقم التليفون',
			phoneRegex: 'رقم التليفون',
			msg: 'رسالة',
			amount: 'قيمة الهدية',
			creditAmount: 'الرصيد',
			card_number: 'رقم الكارت',
			expiry_date: ' تاريخ صلاحية الكارت',
			card_security_code: 'الكود السري',
			phoneNumber: 'رقم التليفون',
			phoneNumbers: 'ارقام التليفون',
			prefix: 'اسم البرومو'
		},
		messages: {
			email: (field) => `${field} غير صالح`,
			length: (field) => `${field} غير صالح`,
			required: (field) => `يرجى ادخال ${field} `,
			regex: (field) => {
				if (field.includes('رقم التليفون')) {
					return `رقم التليفون لازم يكون 11 رقم و يبدأ ب 01.`;
				} else if (field.includes('اسم') || field.includes('الأسم')) {
					return `خلي بالك ${field} لازم يكون حروف انجليزي`;
				} else if (field.includes('الرصيد')) {
					return 'الرصيد لازم يكون أرقام'
				}
				return `كلمة السر لازم تحتوي علي الاقل علي حرف كبير و حرف صغير و حرف خاص و رقم`;
			},
			min: (field, number) => `${field} لازم تكون علي الأقل ${number} حروف.`,
			max: (field, number) => {
				if (field == 'الأسم') {
					return `${field} مينفعش يكون اكثر من ${number} حروف.`
				}
				return `${field} لا يزيد عن ${number} حروف.`
			},
			is: `كلمة السر غير متطابقة.`
		}
	}
}